import type { ControlProperty } from '../../../../../common/models/forms.model';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { ListRange, SearchCriteriaBase } from '../../../../../common/models/list.model';
import { mustNotBeBlankValidator } from '../../../../../common/utils/validators';
import { Validators } from '@angular/forms';

export class YardSpotConfigurationModel {
  id: number;
  name: string;
  description: string;
  truckType: string;

  constructor(params?: YardSpotConfigurationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class YardSpotForm {
  constructor(
    model: YardSpotConfigurationModel,
    public id: ControlProperty<number> = model.id,
    public name: ControlProperty<string> = [
      model.name,
      [Validators.maxLength(10), Validators.required, mustNotBeBlankValidator],
    ],
    public description: ControlProperty<string> = model.description,
    public truckType: ControlProperty<string> = model.truckType,
  ) {}
}

export class YardSpotSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: YardSpotSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
